import './index.scss'
import AnimatedLetters from '../../components/AnimatedLetters'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ConnectVioletSS from '../../assets/images/connect-violet.jpg'
import PortfolioSS from '../../assets/images/portfolio.png'
import SEEDSS from '../../assets/images/SEED-logo.png'
import GooglePic from '../../assets/images/LSLS.JPG'
import LatitudePic from '../../assets/images/Latitude.jpg'
import WalmartPic from '../../assets/images/Walmart.jpg'

const Projects = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        const timer = setTimeout(() => setLetterClass('text-animate-hover'), 7500)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div className='container projects-page'>
            <div className='text-zone'>
                <div className='heading'>
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['My', 'Projects', 'and', 'Experiences']}
                            idx={17}
                        />
                    </h1>
                </div>
                <div className='row'>
                    <div className='project'>
                        <Link to="/projects/personal-portfolio">
                            <img className="pics" src={PortfolioSS} alt="cv pic" />
                        </Link>
                        <h3>Personal Portfolio!</h3>
                    </div>
                    <div className='project'>
                        <Link to="/projects/connect-violet">
                            <img className="pics" src={ConnectVioletSS} alt="portfolio pic" />
                        </Link>
                        <h3>ConnectViolet!</h3>
                    </div>
                    <div className='project'>
                        <Link to="/projects/SEED">
                            <img className="pics" src={SEEDSS} alt="portfolio pic" />
                        </Link>
                        <h3>SEED!</h3>
                    </div>
                </div>
                <div className='row'>
                    <div className='project'>
                        <Link to="/projects/LSLS">
                            <img className="pics" src={GooglePic} alt="cv pic" />
                        </Link>
                        <h3>Google LSLS!</h3>
                    </div>
                    <div className='project'>
                        <Link to="/projects/latitude">
                            <img className="pics" src={LatitudePic} alt="icon button for walmart" />
                        </Link>
                        <h3>Latitude Fellowship!</h3>
                    </div>
                    <div className='project'>
                        <Link to="/projects/walmart">
                            <img className="pics" src={WalmartPic} alt="icon button for walmart" />
                        </Link>
                        <h3>Sophomore Summit!</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects
